import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { DataGrid } from '@material-ui/data-grid';
import MenuItem from '@material-ui/core/MenuItem';

import UserList from "./UserList";

import { UserContext } from "../../context/user-context";
import { SessionContext } from "../../context/session-context";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';


var handleError = function (err) {
  console.log(err);
  return new Response(JSON.stringify({
    code: 400,
    message: 'Stupid network Error'
  }));
};

export default function MyDetailsPanel(props) {

  const useStyles = makeStyles({
    root:{
      width: props.width,
      minWidth: 380, 
      maxHeight: 500,

    },
    userList:{
      '& .MuiButton-text': {
        textTransform: 'none',
      },
    },
    selectButton:{
      marginTop: 20,
      backgroundColor:'#2D2F88',
      color: '#FFF',
      '&:hover': {
        color: '#F6A036',
      },
    },
    textField:{
      width:'60%',
      minWidth: 140,
    }, 
    textFieldLong:{
      width:'80%',
      minWidth: 200,
    },
    styleContainer:{
      marginLeft:10,
      border: '1px solid #D2D2D8',
      '& .MuiInputBase-root': {
        fontSize: 12,
      },
      '& .MuiInputLabel-root': {
        fontSize: 14,
      },
    }, 
    userContainer:{
      margin:10,
    },
    userListContainer:{
      height: '60vh',
      overflowY: 'auto'
    },
    actionButton:{
      color: '#FFFFFF',
      backgroundColor: '#0C4C35',
      '&:hover': {
        color: '#FFFFFF',
        backgroundColor: '#63D764',
      },
      minWidth:120,
      height:32,
      marginTop: 10,
      marginRight: 10,
      fontSize:12
    },
    personIcon: {
      width: 48,
      height: 48,
      padding:0,
      color:'#99E79D'
    },
    personIconDisabled: {
      width: 48,
      height: 48,
      padding:0,
      color:'#bababa'
    },
});


  const classes = useStyles();
  const [sState] = useContext(SessionContext);

  const [isNewUser, setIsNewUser] = useState(false);
  const [userid, setUserid] = useState(0);
  const [name, setName] = useState('');
  const [hasNameError, setHasNameError] = useState(false);
  const [hasNameErrorLabel, setHasNameErrorLabel] = useState('');
  const [email, setEmail] = useState('');
  const [hasEmailError, setHasEmailError] = useState(false);
  const [hasEmailErrorLabel, setHasEmailErrorLabel] = useState('');
  const [status, setStatus] = useState('');
  const [uType, setUType] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [updateEnabled, setUpdateEnabled] = useState(false);

  const [severity, setSeverity] = useState('success');
  const [msg, setMsg] = useState('');
  const [snackOpen, setSnackOpen] = useState(false);

  const [userRows, setUserRows] = useState([]);
  const [userActive, setUserActive] = useState(0);
  const [userDisabled, setUserDisabled] = useState(0);

  /**
   * Loads and displays the current user details.
  */
  useEffect(() => {
    getUserList(sState.aid);
  },[]);

  const getUserList = (clientid) => {
    const abortController = new AbortController();
      let mounted = true;
      (async () => {  
        const res = await fetch(process.env.REACT_APP_FIND_API+'/find/client/users?id='+parseInt(clientid), {
          method: 'GET',
          headers: {'Content-Type': 'application/json'},
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            setUserRows(data.users);

            let activeU = 0;
            let disabledU = 0;
            data.users.forEach(function (p) {
              if (p.status === 'active'){ activeU = activeU+1; } else {disabledU = disabledU+1;}
            })
            setUserActive(activeU);
            setUserDisabled(disabledU);

          } else {
            setUserRows([]);
          }
        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
    
    })();

  }
  
  const handleNewUser = () => {
    setIsNewUser(true);
    setUserid(-1);
    setName('');
    setEmail('');
    setStatus('active');
    setUType('user');
    setUpdateEnabled(false);
    setIsDisabled(false);
  }

  const handleSaveNewUser = () => {

    let hasError = false;
    if (name.length < 1){ setHasNameError(true); setHasNameErrorLabel('Name is required'); hasError = true;} else { setHasNameError(false); setHasNameErrorLabel('') }
    if (email.length < 1){ setHasEmailError(true); setHasEmailErrorLabel('Email is required'); hasError = true;} else { setHasEmailError(false); setHasEmailErrorLabel('');}

    if (!hasError){
      const abortController = new AbortController();
      const request = {
        ident:sState.ident,
        uid:sState.userid,
        userid:-1,
        companyid:sState.aid,
        username: name,
        email: email,
        status: status,
        utype: uType
      };
  
      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/users/save', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            setSeverity('success')
            setMsg('User successfully added.')
            setSnackOpen(true);
            handleUpdateComplete();
            
          } else {
            setSeverity('error')
            switch(data.message){
              case "email_already_exist":
                setMsg('Failed. Duplicated email.');
              break;
              default:
                setMsg('Failed to add new user');
              break;
            }
            setSnackOpen(true);
          }
        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
      })();
    }


  }

  /**
   * Saves the changes.
   */
  const handleUpdate = () => {
    let hasError = false;
    if (name.length < 1){ setHasNameError(true); setHasNameErrorLabel('Your name is required'); hasError = true;} else { setHasNameError(false); setHasNameErrorLabel('') }
    if (email.length < 1){ setHasEmailError(true); setHasEmailErrorLabel('Your email is required'); hasError = true;} else { setHasEmailError(false); setHasEmailErrorLabel('');}


    if (!hasError){
      const abortController = new AbortController();
      const request = {
        ident:sState.ident,
        uid:sState.userid,
        userid:userid,
        name: name,
        email: email,
        status: status,
        utype: uType
      };
  
      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/users/update', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        }).catch(handleError);
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            setSeverity('success')
            setMsg('Update complete.')
            setSnackOpen(true);
            handleUpdateComplete();
            
          } else {
            setSeverity('error')
            switch(data.message){
              case "email_already_exist":
                setMsg('Failed. Duplicated email.');
              break;
              default:
                setMsg('Failed to update details..');
              break;
            }
            setSnackOpen(true);
          }
        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
      })();
    }

  };

  const handleUpdateComplete = () => {
    getUserList(sState.aid);
    handleUserClear();
  }

/**
   * Handles the password reset..
   */
 const handleReset = () => {
  let hasError = false;

  if (!hasError){
    const abortController = new AbortController();
    const request = {
      email:email,
    };

    let mounted = true;
    (async () => {
      const res = await fetch(process.env.REACT_APP_FIND_API+'/users/forgotten', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(request),
        signal: abortController.signal,
      }).catch(handleError);
      const data = await res.json();
      if (mounted) {
        if (data.status === "success"){
          setSeverity('success')
          setMsg('A password reset email has been sent to the user.')
          setSnackOpen(true);
        } else {
          setSeverity('error')
          setMsg('Failed to send password reset email.')
          setSnackOpen(true);
        }
      }
      const cleanup = () => {
        mounted = false;
        abortController.abort();
      };
      return cleanup;
    })();
  }

};

  const handleClose = () => {
    setSnackOpen(false);
  }

  const handleUserClear = () => {
    setIsNewUser(false);
    setUserid(-1);
    setName('');
    setEmail('');
    setStatus('active');
    setUType('user');
    setUpdateEnabled(false);
    setIsDisabled(true);
  }

  const handleUserSelectClick = (uid) => {
    userRows.forEach(function (p) {
      if (p.userid === uid){
        setUserid(p.userid);
        setName(p.username);
        setEmail(p.email);
        setStatus(p.status);
        setUType(p.utype);
        setUpdateEnabled(true);
        setIsDisabled(false);
        setIsNewUser(false);
        return;
      }
  });


  } 

  return (
    <div className={classes.root}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackOpen} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity}>
          {msg}
          </Alert>
      </Snackbar>
      <Grid container>
        <Grid item xs={6}>
          <div className={classes.userListContainer}>
            <UserList rows={userRows} handleClick={handleUserSelectClick}/>
          </div>
        </Grid>
        <Grid item xs={6}>
          <Grid container >
            <Grid item xs={2}/>
            <Grid item xs={4}>
              <Grid container >
                <Grid item xs={4}>
                  <AccountCircleIcon className={classes.personIcon}/>
                </Grid>
                <Grid item xs={8}>
                    <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >Active Users </Box></Box>
                    <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={14} >{userActive}</Box></Box> 
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <Grid container >
                <Grid item xs={4}>
                  <AccountCircleIcon className={classes.personIconDisabled}/>
                </Grid>
                <Grid item xs={8}>
                    <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={12} >Disabled Users </Box></Box>
                    <Box display="flex" ><Box fontWeight="fontWeightBold" fontSize={14} >{userDisabled}</Box></Box> 
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2}/>
          </Grid>
          <div className={classes.styleContainer}>
            <Grid container className={classes.userContainer}>
              <Grid item xs={12} >
                {isNewUser ?  
                <Box fontSize={14}>Enter new user details</Box> : <Box fontSize={14}>Existing user details</Box>}
                
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField className={classes.textField} error={hasNameError} disabled={isDisabled} helperText={hasNameErrorLabel} name="name" label="Name" size="small" margin="dense" variant="outlined" value={name} onChange={e => setName(e.target.value)} required/> 
              </Grid>
              <Grid item xs={null} md={4}></Grid>
              <Grid item xs={12} md={8}>
                <TextField className={classes.textFieldLong} error={hasEmailError} disabled={isDisabled} helperText={hasEmailErrorLabel} name="email" label="Email" size="small" margin="dense" variant="outlined" value={email} onChange={e => setEmail(e.target.value)} required/> 
              </Grid>
              <Grid item xs={null} md={4}></Grid>
              <Grid item xs={12} md={4}>
                <TextField className={classes.textField} name="utype" disabled={isDisabled} label="User type" size="small" margin="dense" variant="outlined" value={uType} onChange={e => setUType(e.target.value)} select>
                    <MenuItem value={'user'}>User</MenuItem>
                    <MenuItem value={'manager'}>Manager</MenuItem>
                    <MenuItem value={'admin'} disabled={true}>Admin</MenuItem>
                </TextField>  
              </Grid>
              <Grid item xs={null} md={8}></Grid>
              <Grid item xs={12} md={4}>
                <TextField className={classes.textField} name="status" disabled={isDisabled} label="Status" size="small" margin="dense" variant="outlined" value={status} onChange={e => setStatus(e.target.value)} select>
                    <MenuItem value={'active'}>Active</MenuItem>
                    <MenuItem value={'disabled'}>Disabled</MenuItem>
                </TextField> 
              </Grid>
              <Grid item xs={null} md={8}></Grid>
              <Grid item xs={12} md={12}>
                {isNewUser ?  
                <Button className={classes.actionButton} onClick={handleSaveNewUser} >
                  Add User
                </Button> : <Button className={classes.actionButton} onClick={handleUpdate} disabled={!updateEnabled}>
                  Update
                </Button>}
                <Button className={classes.actionButton} onClick={handleReset} disabled={!updateEnabled}>
                  Reset password
                </Button>
                <Button className={classes.actionButton} onClick={handleNewUser}>
                  Add New User
                </Button>
              </Grid>

            </Grid>
          </div>
        </Grid>
      </Grid>
    </div> 
  );
}